import { Box, Stack } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import './style.css'

import { EffectCoverflow } from 'swiper/modules';
import { NavLink, titleToUrl, useSelector } from '../../../imports/generalImport';
import MobileSectionTitle from '../mobileProductCard/MobileSectionTitle';


const MobileFeatureComponent = () => {
    const featuredData = useSelector((state) => state?.MobileHomepage?.allData?.featured);

    return (
        <Box
            component={"div"}
            sx={{
                my: 3,
                pt: 3.5,
                pb: 1.2,
                backgroundColor: "rgb(237 246 255)",
            }}
        >
            <Stack
                sx={{
                    pl: 1,
                }}
            >
                <MobileSectionTitle
                    sectionTitle={"Featured Gift Vouchers"}
                />
            </Stack>

            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={'auto'}
                loop={true}
                coverflowEffect={{
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                }}
                pagination={false}
                modules={[EffectCoverflow]}
                className="mySwiper"
            >
                {featuredData?.map((item) => {
                    return (
                        <SwiperSlide key={`featuredData-${item?.id}`}>
                            <NavLink
                                to={`/card-details/${item?.id}/${titleToUrl(item?.title)}`}
                                style={{
                                    textDecoration: "none",
                                }}
                            >
                                <Box
                                    component={"img"}
                                    src={item?.featured_img}
                                    alt={item?.title}
                                    sx={{
                                        width: 132,
                                        height: 189
                                    }}
                                />
                            </NavLink>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </Box>
    )
}

export default MobileFeatureComponent